<template>
  <div class="Help__Wrapper">
    <div
      class="Interface__Help"
      @click="getFile()"
    >
      <div
        class="Interface__HelpIcon"
      />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    getFile () {
      let fileName = 'Tuto Corail_v3a_FR.pdf'
      switch (this.$store.getters.selectedLang) {
        case 'fr':
          fileName = 'Tuto Corail_v3a_FR.pdf'
          break
      }
      window.open('assets/' + fileName, '_blank')
    }
  }
}
</script>

<style>
.Help__Window {
  height: auto;
  background: white;
  position: absolute;
  padding: 0.5em;
  border-radius: 10px;
  filter: drop-shadow(0 1mm 1mm rgb(0, 0, 0, 0.3));
}

.Help__Wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  pointer-events: none;
}

.Help__ClosingWindow {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: auto;
  background: rgba(0,0,0,0.5)
}

@media screen and (min-width: 1300px) {

.Interface__Help{
  position: absolute;
  right: 55px;
  top: 55px;
  width: 55px;
  height: 55px;
  background: white;
  display: flex;
  justify-content: center;
  border-radius: 100%;
  pointer-events: auto;
   filter: drop-shadow(0 1mm 1mm rgb(0, 0, 0, 0.3));
}
.Help__Window {
  right: 55px;
  top: 55px;
  width: 25em;
}

.Help__Text {
  text-align: center;
  font-size: 1em;
}

}

@media screen and (max-width: 1300px) {

.Interface__Help{
  position: absolute;
  right: 55px;
  top: 30px;
  width: 42px;
  height: 42px;
  background: white;
  display: flex;
  justify-content: center;
  border-radius: 100%;
  pointer-events: auto;
  filter: drop-shadow(0 1mm 1mm rgb(0, 0, 0, 0.3));
}
.Help__Window {
    right: 55px;
  top: 30px;
  width: 15em;
}

.Help__Text {
  text-align: center;
  font-size: 0.8em;
}

}

.Interface__HelpIcon{
  width: 40%;
  height: 40%;
  margin: auto;
  background: black;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  mask-image: url('../../assets/icons/help.svg');
}
</style>
